import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../stylesheets/style.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Config, Routes } from "../../configurations/config";
import { Col, Button, Form, FormGroup, Label, Input } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { Ticket_Variables } from "../ticketModule/variables/Ticket_Variables";
import { UserConsumer } from "../../UserContext";
import { Feedback_APIs } from "./Feedback_APIs";
import PageLoader from "../../components/PageLoader";
import FormStatus from "../../components/FormStatus";
import CustomReactSelect from "../../components/CustomReactSelect";
import { AlertPopups } from "../../components/AlertPopups";

const validation = Yup.object().shape({
	description: Yup.string()
		.required("Description is required")
		.typeError("Invalid input")
		.max(500, "Max 500 characters allowed"),
	title: Yup.string()
		.required("Title is required")
		.typeError("Invalid input")
		.max(500, "Max 255 characters allowed"),
	selectPriority: Yup.string()
		.required("Select Priority")
		.typeError("Invalid input")
		.nullable(),
});
let token = null;
class EditFeedback extends Component {
	constructor(props) {
		super(props);
		this.state = {
			title: "",
			description: "",
			attachedFile: "",
			attachedFileName: "",
			attChanged: false,
			fileErr: false,
			showLoader: true,
			selectPriority: "",
			titleErr: false,
			descriptionErr: false,
		};
	}
	componentDidMount() {
		this.getFeedbackDetails();
	}
	getFeedbackDetails = () => {
		var self = this;
		var headers = {
			Authorization: `Bearer ${token}`,
		};

		axios
			.get(
				`${Feedback_APIs.GetFeedbackDetails_API}${Number(
					self.props.match.params.feedbackId
				)}`,
				{
					headers: headers,
				}
			)
			.then(function (response) {
				self.setState({
					showLoader: false,
					title: response.data.title,
					description: response.data.description,
					attachedFile: response.data.attachedFile,
					attachedFileName: response.data.attachedFile,
					selectPriority:
						response.data.priority === 1
							? { value: 1, label: "High " }
							: response.data.priority === 2
							? { value: 2, label: "Medium" }
							: { value: 3, label: "Low" },
				});
			})
			.catch((error) => {
				self.setState({
					showLoader: false,
				});
			});
	};
	handleChange = (event) => {
		if (!event.target) {
			return this.setState({ selectPriority: event });
		}
		const target = event.target;
		const value = target.value;
		const name = target.name;
		if (target.type === "file") {
			if (event.target.files[0] !== undefined) {
				if (
					["image/jpeg", "image/jpg", "image/png"].includes(
						event.target.files[0].type
					)
				) {
					this.setState(
						{
							fileErr: false,
							[name]: target.files[0],
							attachedFileName: target.files[0].name,
							attChanged: true,
						},
						() => {
							document
								.getElementById("attLink")
								.removeAttribute("href");
						}
					);
				} else {
					this.setState({
						fileErr: true,
					});
				}
			}
		} else {
			this.setState({
				[name]: value,
				titleErr: [name] === "title" && false,
				descriptionErr: [name] === "description" && false,
			});
		}
	};
	handleSubmit = () => {
		let self = this;
		let temp = self.state.title.trim().length;
		let tempDesc = self.state.description.trim().length;
		if (temp < 1) return this.setState({ titleErr: true });
		if (tempDesc < 1) return this.setState({ descriptionErr: true });
		if (this.state.fileErr === false) {
			AlertPopups.confirmBox
				.fire({
					text: `${AlertPopups.confirmMsg}`,
				})
				.then((result) => {
					if (result.value) {
						let body = {};
						body.id = Number(self.props.match.params.feedbackId);
						body.title = self.state.title;
						body.description = self.state.description;
						body.priority = self.state.selectPriority.value;
						body.attachedFile = self.state.attachedFile;
						self.editFeedback(body);
					}
				});
		}
	};
	editFeedback = (body) => {
		this.setState({
			showLoader: true,
		});
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		let self = this;
		axios
			.put(
				`${Feedback_APIs.EditFeedback_API}${Number(
					self.props.match.params.feedbackId
				)}`,
				body,
				{
					headers: headers,
				}
			)
			.then(function (response) {
				if (response.status === 204) {
					if (self.state.attChanged) {
						self.sendnewAttachment();
					} else {
						self.setState({
							showLoader: false,
						});
						AlertPopups.successAlert.fire({
							text: `${AlertPopups.successMsg}`,
						});
						self.props.history.push(Routes.Bug);
					}
				}
			})
			.catch((error) => {
				self.setState({
					showLoader: false,
				});
			});
	};
	sendnewAttachment = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		let self = this;
		let formdata = new FormData();
		formdata.append(
			"FeedbackId",
			Number(this.props.match.params.feedbackId)
		);
		formdata.append("Attachment", this.state.attachedFile);
		axios
			.put(
				`${Feedback_APIs.EditAttachment_API}${Number(
					this.props.match.params.feedbackId
				)}`,
				formdata,
				{
					headers: headers,
				}
			)
			.then(function (response) {
				if (response.status === 204) {
					self.setState({
						showLoader: false,
					});
					AlertPopups.successAlert.fire({
						text: `${AlertPopups.successMsg}`,
					});
					self.props.history.push(Routes.Bug);
				}
			})
			.catch((error) => {
				self.setState({
					showLoader: false,
				});
			});
	};
	deleteAttachement = () => {
		this.setState({ attachedFile: "" });
	};
	render() {
		if (this.state.showLoader) {
			return (
				<UserConsumer>
					{(userDetails) => {
						token = userDetails.token;
						return <PageLoader />;
					}}
				</UserConsumer>
			);
		} else
			return (
				<div className="container-fluid mt-3 pl-4 pr-4">
					<FormStatus
						title="Edit Feedback"
						formStatus={this.props.location.state.itemStatus}
						className="create-request d-flex align-items-center"
						onClick={() => {
							this.props.history.push(Routes.Bug);
						}}
						navigateBack={true}
					/>

					<UserConsumer>
						{(userDetails) => {
							token = userDetails.token;
							return (
								<>
									<Formik
										initialValues={this.state}
										enableReinitialize={true}
										onSubmit={(values) =>
											this.handleSubmit(values)
										}
										validationSchema={validation}
										validateOnChange={true}
									>
										{({ errors, handleSubmit }) => (
											<Form
												className="my-2 itemReqForm"
												onSubmit={handleSubmit}
											>
												<FormGroup
													row
													id="row0"
													className="bottom-spacing topBorders"
												>
													<Label sm={12}>
														Edit Feedback
													</Label>
												</FormGroup>
												<FormGroup
													row
													className="bottom-spacing rowStyle1"
												>
													<Label for="title" sm={2}>
														Title
														<span className="required">
															*
														</span>
													</Label>
													<Col sm={10}>
														<Input
															type="text"
															value={
																this.state.title
															}
															name="title"
															id="title"
															bsSize="md"
															maxLength="300"
															autoComplete="off"
															onChange={(e) =>
																this.handleChange(
																	e
																)
															}
															placeholder="Title"
															className={`formValueInput ${
																errors.title ||
																this.state
																	.titleErrn
																	? "h-auto invalid"
																	: "h-auto"
															}`}
														/>
													</Col>
												</FormGroup>
												<FormGroup
													row
													className="bottom-spacing rowStyle2"
												>
													<Label
														for="selectPriority"
														sm={2}
													>
														Priority
														<span className="required">
															*
														</span>
													</Label>
													<Col sm={10}>
														<CustomReactSelect
															options={
																Ticket_Variables.feedbackPriority
															}
															name="selectPriority"
															id="selectItems"
															placeholder=""
															onChange={(event) =>
																this.handleChange(
																	event
																)
															}
															value={
																this.state
																	.selectPriority
															}
															className={`formValueInput ${
																errors.selectPriority
																	? "h-auto invalid"
																	: "h-auto"
															}`}
														/>
													</Col>
												</FormGroup>
												<FormGroup
													row
													className="bottom-spacing row1"
												>
													<Label
														for="description"
														sm={2}
													>
														Description
														<span className="required">
															*
														</span>
													</Label>
													<Col sm={10}>
														<Input
															type="textarea"
															name="description"
															id="description"
															className={`formValueInput ${
																errors.description ||
																this.state
																	.descriptionErr
																	? "h-auto invalid"
																	: "h-auto"
															}`}
															onChange={(event) =>
																this.handleChange(
																	event
																)
															}
															value={
																this.state
																	.description
															}
															maxLength="500"
														/>
													</Col>
												</FormGroup>
												<FormGroup
													row
													className="bottom-spacing row2 bottomBorders"
												>
													<Label
														for="fileName"
														sm={2}
													>
														Attachment
													</Label>
													<Col md={9}>
														<div className="fb-att">
															<Input
																id="fileName"
																type="text"
																className="position-relative pl mb-1 p-4"
																readOnly
																onClick={() =>
																	document
																		.getElementById(
																			"attachedFile"
																		)
																		.click()
																}
																accept="image/png,image/jpeg,image/jpg"
															/>

															<Label className="attLabel">
																{this.state
																	.attachedFile ? (
																	<a
																		href={`${Config.server_url}${this.state.attachedFileName}`}
																		target="_blank"
																		rel="noopener noreferrer"
																		id="attLink"
																	>
																		{this
																			.state
																			.attachedFileName &&
																			this.state.attachedFileName.slice(
																				0,
																				40
																			)}
																	</a>
																) : (
																	<span
																		onClick={() =>
																			document
																				.getElementById(
																					"attachedFile"
																				)
																				.click()
																		}
																	>
																		{" "}
																		Attachment
																	</span>
																)}
															</Label>

															<Input
																id="attachedFile"
																name="attachedFile"
																type="file"
																className="d-none"
																onChange={(e) =>
																	this.handleChange(
																		e
																	)
																}
															/>
															<FontAwesomeIcon
																icon={
																	faPaperclip
																}
																size="1x"
																color="black"
																className="attIcon"
																onClick={() =>
																	document
																		.getElementById(
																			"attachedFile"
																		)
																		.click()
																}
															/>
															{this.state
																.fileErr && (
																<div className="input-feedback">
																	Only
																	".jpeg",".jpg",".png"
																	type files
																	allowed
																</div>
															)}
														</div>
													</Col>
													<Col md={1}>
														<FontAwesomeIcon
															icon={faWindowClose}
															className="att-remove-icon"
															color="keppel"
															onClick={
																this
																	.deleteAttachement
															}
														/>
													</Col>
												</FormGroup>
												<div className="btns mt-3">
													<Button className="submit-btn ">
														Update
													</Button>
												</div>
											</Form>
										)}
									</Formik>
								</>
							);
						}}
					</UserConsumer>
				</div>
			);
	}
}
export default EditFeedback;
